import React from 'react';
import PropTypes from 'prop-types';
import ModalHeader from './ModalHeader';
import ModalFooter from './ModalFooter';
import ModalBody from './ModalBody';
import ModalPadding from './ModalPadding';
import Button from '../Buttons/Button';

const ConfirmModal = ({ children, title, onConfirmClick, confirmText, onCloseClick, loading }) => (
  <div className="confirm-modal">
    <ModalHeader title={title} onCloseClick={onCloseClick} />

    <form>
      <ModalBody>
        <ModalPadding>
          {children}
        </ModalPadding>
      </ModalBody>

      <ModalFooter>
        <Button onClick={e => onConfirmClick(e)} loading={loading}>{confirmText}</Button>
      </ModalFooter>
    </form>
  </div>
);

ConfirmModal.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  title: PropTypes.string,
  onConfirmClick: PropTypes.func,
  confirmText: PropTypes.string,
  onCloseClick: PropTypes.func,
  loading: PropTypes.bool,
};

export default ConfirmModal;



// WEBPACK FOOTER //
// ./library/app/components/Global/Modals/ConfirmModal.js